export default {
    home: '首页',
    product: '产品中心',
    solutions: '成功案例',
    aboutUs: '关于我们'
}